import React from 'react'
import * as E from '../elementor'
import { useFlags } from 'gatsby-plugin-launchdarkly'
import { getReportingAdapter } from '../reporting/get-reporting-adapter'
import { EventPrefix, Trigger } from '@pathccm/common-analytics/events'

const DownloadInHero = ({ section }) => {
  let heading: E.HeadingWidget[] = []
  let button: E.ButtonWidget[] = []

  const productArea = 'Provider Download'
  let primaryHeader = ''
  let downloadLink = ''

  const { marketingSiteSegmentTransition } = useFlags()
  const reporting = getReportingAdapter(marketingSiteSegmentTransition)

  if (section !== undefined) {
    ({ heading, button } = E.collect(section))
    primaryHeader = heading[0]?.title ?? ''
    downloadLink = button[0]?.link ?? ''
  }

  // Track the download event in Amplitude
  const triggerDownloadEvent = async () => {
    if (marketingSiteSegmentTransition) {
      reporting.track({
        eventName: {
          prefix: EventPrefix.MARKETING_SITE,
          trigger: Trigger.CONTENT_DOWNLOAD
        },
        properties: {
          download_triggered: true,
          product_area: productArea
        }
      })
    }
  }

  return (
    <section className={['download-in-hero', section?.cssClasses].join(' ')}>
      <div className='download-call-to-action-wrapper'>
        <h6 className='primary-header'>{primaryHeader}</h6>
        <a className='download-hero-link' href={downloadLink} target='_blank' rel='noopener noreferrer' download>
          <button className='download-hero-button' onClick={triggerDownloadEvent}>Download PDF</button>
        </a>
      </div>
    </section>

  )
}

export default DownloadInHero
